export default __webpack_public_path__ + "components/smartbar/static/icon-close-547720209942f970388a9d2e9568a0c0.svg";